import styled from 'styled-components';

export const StatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  justify-content: center;
  text-align: center;
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StatNumber = styled.span`
  font-size: 3rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -1px;

  @media (max-width: 768px) {
    font-size: 2.25rem;
  }
`;

export const StatLabel = styled.span`
  font-size: 0.9rem;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
`;

export const StoryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const StoryImage = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 16px;

  @media (max-width: 968px) {
    height: 280px;
  }
`;

export const StoryTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const StoryHeading = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  color: #1f2937;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const StoryParagraph = styled.p`
  color: #4b5563;
  font-size: 1.05rem;
  line-height: 1.8;
`;

export const PullQuoteWrap = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
`;

export const PullQuoteMark = styled.div`
  font-size: 4rem;
  line-height: 1;
  color: #d1d5db;
  margin-bottom: 0.5rem;
`;

export const PullQuoteText = styled.p`
  font-size: 1.75rem;
  font-weight: 500;
  color: #1f2937;
  line-height: 1.5;
  font-style: italic;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

export const PullQuoteAuthor = styled.p`
  margin-top: 1.5rem;
  font-size: 0.95rem;
  color: #6b7280;
  font-weight: 600;
`;
